var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Loader from '@Components/Loader';
import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import Divider from '@mui/material/Divider';
import NewCard from '@Components/NewCard';
import Container from '@Components/Container';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import SupervisorAccountIcon from '@mui/icons-material/SupervisorAccount';
import InfoField from './componentts/InfoField';
import { useUserMetadataField } from '../../../../hooks/useUserMetadataField';
import { getProfileInformation } from '../../../../services/profile';
export var Profile = function () {
    var _a = useState(false), loading = _a[0], setLoading = _a[1];
    var _b = useState(false), isEditing = _b[0], setIsEditing = _b[1];
    var _c = useState('Banco Nacional de Crédito'), institutionName = _c[0], setInstitutionName = _c[1];
    var handleEditClick = function () {
        setIsEditing(true);
    };
    var handleChange = function (event) {
        setInstitutionName(event.target.value);
    };
    var handleSaveClick = function () {
        setIsEditing(false);
        // Aquí puedes hacer algo como llamar a una API para guardar el valor
    };
    var financialInstitutionId = useUserMetadataField('financialInstitutionId');
    var _d = useState({
        name: '',
        createdAt: '',
        adminName: '',
    }), profile = _d[0], setProfile = _d[1];
    var _e = useState(false), errorSettings = _e[0], setErrorSettings = _e[1];
    useEffect(function () {
        var loadSettings = function () { return __awaiter(void 0, void 0, void 0, function () {
            var preferences, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        setLoading(true);
                        return [4 /*yield*/, getProfileInformation(financialInstitutionId)];
                    case 1:
                        preferences = _a.sent();
                        console.log('preferences', preferences);
                        setProfile({
                            name: preferences === null || preferences === void 0 ? void 0 : preferences.name,
                            createdAt: preferences === null || preferences === void 0 ? void 0 : preferences.createdAt,
                            adminName: preferences === null || preferences === void 0 ? void 0 : preferences.adminName,
                        });
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        setErrorSettings(error_1.message);
                        console.error("Error loading settings:", error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadSettings();
    }, []);
    return (_jsxs("div", __assign({ style: { padding: '16px' } }, { children: [loading &&
                _jsx(Loader, {}), _jsx(Typography, __assign({ variant: "h5", component: "div", sx: { marginBottom: '8px' } }, { children: "Informaci\u00F3n de la instituci\u00F3n" })), _jsx(Divider, { sx: { marginBottom: '8px' } }), _jsx(NewCard, { children: _jsxs(Container, { children: [_jsx(InfoField, { label: 'Nombre de la instituci\u00F3n', value: profile.name, editable: true }), _jsx(InfoField, { label: 'Fecha de creaci\u00F3n', value: profile.createdAt, icon: CalendarMonthIcon }), _jsx(InfoField, { label: 'Administrador', value: profile.adminName, icon: SupervisorAccountIcon })] }) })] })));
};
export default Profile;
